<template>
  <div class="con" v-loading="loading">
      <div class="text item">
        <network-info :network-info="networkInfo"></network-info>
        <div class="setting">{{$t('lang.wire.functionConfiguration')}}</div>
        <div class="Table-Con">
          <el-form ref="ruleForm" :model="data" label-width="200px" class="demo-ruleForm">
            <el-form-item :label="`${$t('lang.ConfigSetting.Protocol')}：`" prop="name">
              <el-select
                :placeholder="$t('lang.ConfigSetting.pleaseChoose')"
                v-model="data.proto"
                size="mini"
                class="Form-Input-Width">
                <el-option
                  v-for="item in protocol"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="`${$t('lang.ConfigSetting.IPv4address')}：`" prop="ipaddr">
              <el-input
                size="mini"
                class="Form-Input-Width"
                v-model="data.ipaddr"
                @change="ErrorIpaddr(data.ipaddr)">
              </el-input>
              <p class="error-mess" v-if="error.ipaddr">{{$t('lang.ConfigSetting.Pleasecheck')}}</p>
            </el-form-item>
            <el-form-item :label="`${$t('lang.ConfigSetting.IPv4netmask')}：`" prop="region">
              <select-input
                :SelectArr="IPv4protocol"
                :SelectValue="data.netmask"
                @GetSelectValue="GetSelectValue">
              </select-input>
            </el-form-item>
            <el-form-item :label="`${$t('lang.ConfigSetting.UsecustomDNSservers')}：`" prop="region">
              <add-input :dns="data.dns" @GetAddInput="GetAddInput"></add-input>
            </el-form-item>
          </el-form>
        </div>
          <el-button type="danger" size="mini" @click="updateConfig" class="Config-Buttom">
          {{$t('lang.ConfigSetting.SaveApply')}}
        </el-button>
      </div>
  </div>
</template>
<script>
  import SelectInput from "../../../SelectInput/index";
  import AddInput from "../../../AddInput/index";
  import networkInfo from '../../../networkInfo/index'
  import { updateConfig, listConfig, getNetworkInfo } from "@/api/configurationlist";
  import { cloneDeep, isEqual } from 'lodash'
  export default {
    props: ["deviceDid", "deviceSn"],
    data() {
      return {
        protocol: [{ label: this.$t('lang.ConfigSetting.Staticaddress'), value: "static" }],
        protocolVlue: "proto",
        //IPv4子网掩码下拉数组
        IPv4protocol: [
          { label: "255.255.255.0", value: "255.255.255.0" },
          { label: "255.255.0.0", value: "255.255.0.0" },
          { label: "255.0.0.0", value: "255.0.0.0" },
          { label: this.$t('lang.ConfigSetting.custom'), value: "自定义" }
        ],
        IPv4protocolValue: "255.255.255.0",
        //监听到是否修改的值
        WatchData: {
          proto: "",
          ipaddr: "",
          netmask: "",
          macaddr: "",
          dns: "",
          mtu: "",
          metric: ""
        },
        data: {},
        //获取父组件传过来的值
        PropsData: null,
        loading: true,
        //验证
        error: {
          ipaddr: false
        },
        // 网络接口基本信息
        networkInfo: {},
      };
    },
    components: {
      SelectInput,
      AddInput,
      networkInfo
    },
    watch: {
       deviceSn: {
        immediate: true,
        handler(newValue, oldValue) {
          this.getConfig()
        },
      }
    },
    activated() {
      this.fetchNetworkInfo()
      this.timer = setInterval(() => {
        this.fetchNetworkInfo()
      }, 10000)
    },
    deactivated() {
      clearInterval(this.timer)
    },
    beforeDestroy() {
      clearInterval(this.timer)
    },
    methods: {
      // 获取配置参数
      getConfig() {
        this.loading = true
        clearInterval(this.timer)
        listConfig(this.deviceSn, this.deviceDid, [
          {
            section: "mgt",
            config: "network",
            options: [
              { option: "proto" },
              { option: "ipaddr" },
              { option: "netmask" },
              { option: "dns" },
              { option: "macaddr" },
              { option: "mtu" },
              { option: "metric" }
            ]
          }
          ]).then(res => {
            this.data = res.data.data.mess[0].s_objects[0].options;
            this.WatchData = cloneDeep(this.data)
            this.fetchNetworkInfo()
            this.timer = setInterval(() => {
              this.fetchNetworkInfo()
            }, 10000)
            this.loading = false
          }).catch(err => {
            this.$message({
              message: this.$t('lang.request.timeout'),
              type: "warning"
            });
          });
      },
      // 获取接口基本信息
      fetchNetworkInfo() {
        getNetworkInfo(this.deviceDid, this.deviceSn, ['mgt']).then(res => {
          this.networkInfo = res.data.data.mess.mgt
        })
      },
      //接收SelectInput的改变传过来的值
      GetSelectValue(props) {
        this.data.netmask = props;
      },
      //接收AddInput的改变传过来的值
      GetAddInput(props) {
        this.data.dns = props;
      },
      //提交修改
      updateConfig() {
        if (this.error.ipaddr) {
          return;
        }
        if (Object.keys(this.data).length > 0) {
          if(!isEqual(this.WatchData, this.data)) {
            clearInterval(this.timer)
            //提交修改
            updateConfig(this.deviceSn, this.deviceDid, [
              {
                section: "mgt",
                config: "network",
                action: 0,
                index: [0],
                server: "network",
                options: {
                  ...this.data
                }
              }
            ]).then(res => {
              if (res.data.data.mess === 0) {
                this.$message({
                  showClose: true,
                  message: this.$t('lang.ConfigSetting.Successfulconfiguration'),
                  type: "success"
                });
                this.getConfig()
              } else {
                this.$message({
                  showClose: true,
                  message: this.$t('lang.ConfigSetting.Configurationerror'),
                  type: "warning"
                });
                return;
              }
            }).catch((err)=>{
              // console.log('请求超时')
              // console.log(err)
            })
          }else{
            this.$message({
              showClose: true,
                  message: this.$t('lang.ConfigSetting.Nochangesmade'),
                  type: 'warning'
              });
              return
          } 
        }
      },
      //ipv4验证
      ErrorIpaddr(props) {
        let test = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        let retu = false;
        if (!test.test(props)) {
          this.error.ipaddr = true;
          retu = true;
        }
        if (!props) {
          this.error.ipaddr = false;
          retu = false;
        }
        if (!retu) {
          this.error.ipaddr = false;
        }
      },
    },  
  };
</script>
<style src='../../../common.css' scoped></style>
